import cx from 'clsx';
import React, { type ReactNode } from 'react';
import type { ToastContentProps } from 'react-toastify';

import { ReactComponent as CloseIcon } from '@assets/svg/toast-icons/ic-close.svg';
import { ReactComponent as ErrorIcon } from '@assets/svg/toast-icons/ic-error.svg';
import { ReactComponent as NotificationIcon } from '@assets/svg/toast-icons/ic-notification.svg';
import { ReactComponent as SuccessIcon } from '@assets/svg/toast-icons/ic-success.svg';

import style from './style.module.scss';

type ToasterVariant = 'success' | 'info' | 'error';
interface IToastData {
  message: string;
  variant: ToasterVariant;
}

const ToastBody = ({ data, toastProps }: ToastContentProps): ReactNode => {
  const { message, variant } = data as IToastData;
  const { closeToast } = toastProps;

  const toastIcons = {
    success: <SuccessIcon />,
    info: <NotificationIcon />,
    error: <ErrorIcon />,
  };

  return (
    <div
      className={cx(style.toastBody, {
        [style.toastSuccess]: variant === 'success',
        [style.toastError]: variant === 'error',
        [style.toastInfo]: variant === 'info',
      })}
    >
      <div className={style.toastContent}>
        <div className={style.toastIcon}>{toastIcons[variant]}</div>
        <p className={style.toastMessage}>{message}</p>
      </div>

      <div className={style.toastCloseBtn}>
        <CloseIcon className={style.toastCloseButton} onClick={closeToast} />
      </div>
    </div>
  );
};

export default ToastBody;
